import { render } from "./FavoriteLink02.vue?vue&type=template&id=2f6ecc81&scoped=true"
import script from "./FavoriteLink02.vue?vue&type=script&lang=js"
export * from "./FavoriteLink02.vue?vue&type=script&lang=js"

import "../assets/irentcar/css/bundle.min.css?vue&type=style&index=0&id=2f6ecc81&lang=css&scoped=true"
import "../assets/irentcar/css/bootstrap.min.css?vue&type=style&index=1&id=2f6ecc81&lang=css&scoped=true"

import exportComponent from "D:\\WorkSites\\Ticket Marketplace\\irent-ticket-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6ecc81"]])

export default __exports__